// constructor(
//     private title: Title,
//     private meta: Meta
// ) {
//     // meta.addTags([
//     //     { name: 'description', content: 'Title and Meta tags examples' },
//     //     { name: 'viewport', content: 'width=device-width, initial-scale=1' },
//     //     { name: 'robots', content: 'INDEX, FOLLOW' },
//     //     { name: 'author', content: 'ABCD' },
//     //     { name: 'keywords', content: 'TypeScript, Angular' },
//     //     { name: 'date', content: '2018-06-02', scheme: 'YYYY-MM-DD' },
//     //     { httpEquiv: 'Content-Type', content: 'text/html' },
//     //     { property: 'og:title', content: "My Text" },
//     //     { property: 'og:image', content: "My Text" },
//     //     { property: 'og:description', content: "My Text" },
//     //     { property: 'og:url', content: "My Text" },
//     //     { property: 'og:type', content: "website" },
//     //     { charset: 'UTF-8' }
//     // ]);
// }

// addTags(data) {
//     this.meta.addTags(data);
// }

// updateTitle(title: string) {
//     this.title.setTitle(title);
//     this.meta.updateTag({ property: 'og:title', content: title });
// }

// updateOgUrl(url: string) {
//     this.meta.updateTag({ name: 'og:url', content: url }); 
// }

// updateOgImage(url: string) {
//     this.meta.updateTag({ name: 'og:image', content: url }); 
// }

// updateOgDescription(desc: string) {
//     this.meta.updateTag({ name: 'og:description', content: desc }); 
// }

// updateDescription(desc: string) {
//     this.meta.updateTag({ name: 'description', content: desc });
// }

export class MetaTag {
    name: string;
    value: string;
    isFacebook: boolean;

    constructor(name: string, value: string, isFacebook: boolean) {
        this.name = name;
        this.value = value;
        this.isFacebook = isFacebook;
    }
}

import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class SEOService {

    private urlMeta: string = "og:url";
    private titleMeta: string = "og:title";
    private descriptionMeta: string = "og:description";
    private imageMeta: string = "og:image";
    private secureImageMeta: string = "og:image:secure_url";
    private twitterTitleMeta: string = "twitter:text:title";
    private twitterImageMeta: string = "twitter:image";

    constructor(private titleService: Title, private metaService: Meta) { }

    public setTitle(title: string): void {
        this.titleService.setTitle(title);
    }

    public setSocialMediaTags(url: string, title: string, description: string, image: string): void {
        var imageUrl = `http://www.hce.edu.vn${image}`;
        var tags = [
            new MetaTag(this.urlMeta, url, true),
            new MetaTag(this.titleMeta, title, true),
            new MetaTag(this.descriptionMeta, description, true),
            new MetaTag(this.imageMeta, imageUrl, true),
            new MetaTag(this.secureImageMeta, imageUrl, true),
            new MetaTag(this.twitterTitleMeta, title, false),
            new MetaTag(this.twitterImageMeta, imageUrl, false)
        ];
        this.setTags(tags);
    }

    public setSocialMediaTagsGoogle(description: string, keywords: string, author: string): void {
        var tags = [
            new MetaTag('description', description, false),
            new MetaTag('keywords', keywords, false),
            new MetaTag('author', author, false)
        ];
        this.setTags(tags);
    }

    public setSocialMediaTagsFacebook(title: string, image: string, url: string, description: string): void {
        var imageUrl = `http://www.hce.edu.vn${image}`;
        var tags = [
            new MetaTag('og:title', title, true),
            new MetaTag('og:image', imageUrl, true),
            new MetaTag('og:url', url, true),
            new MetaTag('og:description', description, true)
        ];
        this.setTags(tags);
    }

    public setSocialMediaTagsTwitter(title: string, description: string, image: string): void {
        var imageUrl = `http://www.hce.edu.vn${image}`;
        var tags = [
            new MetaTag('twitter:title', title, false),
            new MetaTag('twitter:image', imageUrl, false),
            new MetaTag('twitter:description', description, false),
        ];
        this.setTags(tags);
    }


    private setTags(tags: MetaTag[]): void {
        // console.log(tags);
        tags.forEach(siteTag => {
            // const tag = siteTag.isFacebook ? this.metaService.getTag(`property='${siteTag.name}'`) : this.metaService.getTag(`name='${siteTag.name}'`);
            // if (siteTag.isFacebook) {
            //     this.metaService.updateTag({ property: siteTag.name, content: siteTag.value });
            // } else {
            //     this.metaService.updateTag({ name: siteTag.name, content: siteTag.value });
            // } 
            if (siteTag.isFacebook) {
                this.metaService.getTag(`property='${siteTag.name}'`);
                this.metaService.updateTag({ property: siteTag.name, content: siteTag.value });
            } else {
                this.metaService.getTag(`name='${siteTag.name}'`);
                this.metaService.updateTag({ name: siteTag.name, content: siteTag.value });
            }

        });
    }


}

